<script>
    export default {
        name: 'NormalCell',
        props: {
            //是否使用label
            useLabel: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        methods: {
            createHeaderJSX () {
                return (
                    this.$slots.header && (<div class="normal-cell__hd">
                        {this.$slots.header}
                    </div>)
                );
            },
            createBodyJSX () {
                return (
                    this.$slots.default && <div class="normal-cell__bd">
                        {this.$slots.default}
                    </div>);
            },
            createFooterJSX () {
                return (
                    this.$slots.footer && (
                        <div class="normal-cell__ft">
                            {this.$slots.footer}
                        </div>
                    )
                );
            }
        },
        render () {
            const header = this.createHeaderJSX();
            const body = this.createBodyJSX();
            const footer = this.createFooterJSX();
            return (
                this.useLabel ?
                    <label class="normal-cell">{header}{body}{footer}</label> :
                    <div class="normal-cell">{header}{body}{footer}</div>
            );
        }
    };
</script>
<style scoped lang="less">
    @import "../../assets/less/widgets-var";
    label.normal-cell {
        padding: 0;
    }
    .normal-cell {
        .px2rem(padding, 23);
        .px2rem(padding, 23);
        .px2rem(padding-right, 30);
        .px2rem(padding-left, 30);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 0.42666667rem;
        line-height: 1.41176471;

        &__hd {
            .px2rem(margin-right, 10);
        }

        &__bd {
            flex: 1;
            text-align: left;
        }

        &__ft {
            text-align: right;
            color: @otherTextClr;
        }
    }
</style>
